export default "__VITE_ASSET__BekENgGq__"